import { post } from '@/utils/request'

export function loginByUsername(params = {}) {
  const data = {
    username: params.userPhone,
    password: params.password,
    loginType: params.loginType,
    verifyCode: params.userCode
  }
  return post(`login`, data)
}

export function loginByPassword(params = {}) {
  return post('operations/auth/login', {
    phone: params.userPhone,
    password: params.password
  })
}

export function loginByUserCode(params = {}) {
  return post('auth/smsLogin', {
    phone: params.userPhone,
    smsVerifyCode: params.userCode
  })
}

export function logout() {
  return post(`operations/auth/logout`)
}

export function getQRCode() {
  return post(`auth/weChat/getQRCode`)
}

export function getQRCodeState(
  params = {
    scene: ''
  }
) {
  return post(`auth/wx/getQRCodeState`, {
    scene: params.scene
  })
}

export function bindWechat(params = {}) {
  return post(`user/weChat/bindWeChat`)
}

export function unbindWechat(
  params = {
    verifyCode: ''
  }
) {
  return post(`user/weChat/unbindWeChat`, {
    verifyCode: params.verifyCode
  })
}

export function getBindState() {
  return post('user/weChat/bindState')
}
